import {SelectMultipleFilterDto} from "@/model/api/CriteriaApi"
import {Filter} from "@/model/filter/Filter"

export class SelectMultipleFilter implements Filter {
  name: string
  options: Array<string>
  locked: boolean

  constructor(dto: SelectMultipleFilterDto) {
    this.name = dto.id
    this.options = dto.options
    this.locked = dto.locked === true
  }
}
